import privacyPolicyTemplate from './privacyPolicyTemplate.html';

const privacyPolicyModal = {

    bindings: {
        label: '@',
        onClose: '&'
    },

    template: `
            <a class="terms-link" ng-hide="$ctrl.label" ng-click="$ctrl.openModal()">{{ 'PRIVACY_POLICY' | translate }}</a>
            <a ng-if="$ctrl.label && $ctrl.label.length>0" ng-click="$ctrl.openModal()">{{$ctrl.label}}</a>
        `,

    controller: function ($scope, $ionicModal, $ionicScrollDelegate, $location, $rootScope) {
        this.modal = $ionicModal.fromTemplate(privacyPolicyTemplate, { scope: $scope });

        var self = this;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParam) {
            if (self.closeModal() != null) self.closeModal();
        });

        this.openModal = () => {
            this.modal.show();
            if (this.label && this.label == 'here')
               this.scrollToElement();
        };

        this.closeModal = () => {
            this.modal.hide();
            this.onClose();
        };

        this.scrollToElement = () => {
            $location.hash('CookiesPolicy');
            $ionicScrollDelegate.anchorScroll();
        }
    }
}
export default privacyPolicyModal;


/** WEBPACK FOOTER **
 ** ./src/app/directives/privacyPolicy/privacyPolicy.js
 **/